/* Сектора для вывода в Состоянии лицевого счёта */
export const SectorsForAccruals = [
  'rent',
  'social_rent',
  'capital_repair',
  'heat_supply',
  'water_supply',
  'waste_water',
  'catv',
  'garbage',
  'reg_fee',
  'lease',
  'commercial',
  'gas_supply',
  'communal',
  'cold_water_public',
] as const;
export type AccrualsSector = typeof SectorsForAccruals[number];
